import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { PersDataApiFrom } from '@api-gen/models/pers-data-api-from';
import { RouteEntity } from '@core/router/router.entity';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarComponent } from '@shared/components/avatar/avatar.component';
import { PhoneFormatPipe } from '@shared/pipes';
import { Base64srcPipe } from '@shared/pipes/base64src.pipe';


@Component({
    selector: 'app-user-menu',
    imports: [
        AvatarComponent,
        Base64srcPipe,
        MatMenuModule,
        MatDividerModule,
        PhoneFormatPipe,
        RouterLink,
        TranslateModule,
        MatIconModule,
        MatButtonModule,
    ],
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent {
    @Input()
    public person: PersDataApiFrom;

    public readonly routeEntity: typeof RouteEntity = RouteEntity;
}
